import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPeopleIdCard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPeopleIdCard"><Path fillRule="evenodd" clipRule="evenodd" d="M20.5 22H3.5V2H20.5V22ZM12 16.5C10 16.5 7.48535 18.022 7.48535 20.5156H16.5156C16.5156 18.022 14 16.5 12 16.5ZM12 10C10.6193 10 9.5 11.1193 9.5 12.5C9.5 13.8807 10.6193 15 12 15C13.3807 15 14.5 13.8807 14.5 12.5C14.5 11.1193 13.3807 10 12 10ZM9 6H15V4.5H9V6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPeopleIdCard;
